"use strict";

module.exports = require("./Webcam.js");